"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ContactIcon = function (props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ xmlns: "http://www.w3.org/2000/svg", width: "29", height: "45", viewBox: "0 0 29 45", fill: "none" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_6903_15344)" },
            react_1.default.createElement("path", { d: "M0 34L28.1471 34", stroke: "#3E3C3B", strokeWidth: "2", strokeLinecap: "round" }),
            react_1.default.createElement("path", { d: "M13 5H16.4118", stroke: "#3E3C3B", strokeWidth: "2", strokeLinecap: "round" }),
            react_1.default.createElement("circle", { cx: "14.7059", cy: "38.7059", r: "1", fill: "#3E3C3B", stroke: "#3E3C3B", strokeWidth: "1.41176" })),
        react_1.default.createElement("rect", { x: "1", y: "1", width: "27", height: "43", rx: "4.11765", stroke: "#3E3C3B", strokeWidth: "2" }),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_6903_15344" },
                react_1.default.createElement("rect", { width: "29", height: "45", rx: "5.11765", fill: "white" })))));
};
exports.ContactIcon = ContactIcon;
//# sourceMappingURL=ContactIconSummary.js.map